import { render } from "./QuizNavigation.vue?vue&type=template&id=b5ae1fee"
import script from "./QuizNavigation.vue?vue&type=script&lang=js"
export * from "./QuizNavigation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__